var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgSpinner = function SvgSpinner(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200,
    height: 200,
    viewBox: "0 0 52.917 52.917",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient14061"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7ebfe3",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#75cd64",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient13925",
    x1: 40.619,
    x2: 37.189,
    y1: 15.654,
    y2: 40.677,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#linearGradient14061"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillOpacity: 1,
    stroke: "none",
    strokeLinecap: "square",
    strokeOpacity: 1
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f1f1f1",
    strokeWidth: 23.465,
    d: "M99.889 8.035A91.964 91.964 0 008.035 100 91.964 91.964 0 00100 191.965 91.964 91.964 0 00191.965 100 91.964 91.964 0 00100 8.035a91.964 91.964 0 00-.111 0zM100 32.678A67.321 67.321 0 01167.322 100 67.321 67.321 0 01100 167.322 67.321 67.321 0 0132.678 100 67.321 67.321 0 01100 32.678z",
    opacity: 1,
    transform: "scale(.26458)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient13925)",
    strokeWidth: 6.208,
    d: "M41.172 45.84l-3.983-5.163a17.812 17.812 0 01-24.834-3.338 17.812 17.812 0 013.223-24.983 17.812 17.812 0 0124.984 3.222 17.812 17.812 0 01.057.076l5.162-3.983a24.332 24.332 0 00-.057-.075 24.332 24.332 0 00-34.129-4.403 24.332 24.332 0 00-4.402 34.129 24.332 24.332 0 0033.979 4.517z",
    opacity: 1
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSpinner);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/spinner.bafed94c666c878292bd8ae6631f81dd.svg";